import { render, staticRenderFns } from "./PhoneAffirm.vue?vue&type=template&id=435ed61c&scoped=true&"
import script from "./PhoneAffirm.vue?vue&type=script&lang=js&"
export * from "./PhoneAffirm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneAffirm.vue?vue&type=style&index=0&id=435ed61c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435ed61c",
  null
  
)

export default component.exports